module.exports = __webpack_public_path__ + "img/Butterfly_00220.7dfcb759.png";